import { userConstants } from '../constants';
import { userService } from '../services';
import { alertActions } from './';
import { history } from '../helpers';

export const userActions = {
    login,
    logout,
    setCurrentOffice,
    changepass
};

function setCurrentOffice(id) {

    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.auth_token && user.user) {
        return dispatch => {
            user.user.currentOfficeId=id;
            localStorage.setItem('user', JSON.stringify(user));
            window.location.reload();
            dispatch(alertActions.success('دفتر جاری با موفقیت تغییر یافت'));
        }
    }
}

function login(username, password) {
    return dispatch => {
        dispatch(request({ username }));

        userService.login(username, password)
            .then(
                user => { 
                    dispatch(success(user));
                    dispatch(alertActions.success('ورود موفقیت آمیز'));
                    history.push('/certrequestlist');
                },
                error => {
                    dispatch(failure(error.toString()));
                    console.log(error);
                    dispatch(alertActions.error('نام کاربری یا کلمه عبور صحیح نمی باشد'));
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function changepass(model) {
    return dispatch => {
       

        userService.changepass(model)
            .then(
                user => { 
                   
                    dispatch(alertActions.success('رمز عبور با موفقیت تغییر یافت'));
                    history.push('/login');
                },
                error => {
                   
                    console.log(error);
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

}

function logout() {
    userService.logout();
    return { type: userConstants.LOGOUT };
}
